/*
* Account activation (portal invite, new user welcome, etc)
*/
import * as React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import Login from '../login/';
import ActivateLogin from './activate-login';
import * as ReduxQueries from '../queries';

class ActivateAccount extends AppComp.AppComponentNoWrapper<AppComp.IAppComponentProps, any> {
  public constructor(props: any) {
    super(props, 'app.activate-account.');
  }

  public render() {
    const { branding, ...rest } = this.props;

    return (
      <div>
        <Row><Col xs={12}>&nbsp;</Col></Row>
        <Row>
          <Col xs={4} xsOffset={4}>
            <Row>
              <Col xs={12}>
                <img src={branding.logo.login} />
              </Col>
            </Row>
            <Row>&nbsp;</Row>
            <Row>
              <ActivateLogin />
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): AppComp.IAppComponentProps =>
  ReduxQueries.MapQueryStateToPropsRoot(state, props, null);

export default withRouter<AppComp.IAppComponentProps>(connect(mapStateToProps, {})(ActivateAccount));



// WEBPACK FOOTER //
// ./src/activate-account/index.tsx